module.exports = __webpack_public_path__ + "static/media/Military-Nurse_1_t.6722a88b.jpg";